import { withStyles } from '@material-ui/styles';
import { Form, Formik } from 'formik';
import flowRight from 'lodash.flowright';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import DatepickerRow from '../../../partials/dataRows/DatepickerRow';
import InputRow from '../../../partials/dataRows/InputRow';
import {
  isDefined,
  isStringDefined,
  isStringEmpty,
  isUndefined
} from '../../../utils/isDefined';
import { newUserSubmit } from '../actions/newUserRequest';
import validateSchema from '../actions/validateSchema';
import CustomAddressSelect from '../../../partials/customAddressSelect/CustomAddressSelect';
import { actions as reduxActions } from '../reducers';
import styles, { CUSTOM_STYLES } from '../styles/subscriptionStep';
import MandatoryField from './MandatoryField';
import { translate } from '../../../i18n/I18nProvider';
import withUserCheck from '../../../utils/withUserCheck';

const AddressStep = ({
  handleBack,
  setUserData,
  classes,
  resestUserWizard,
  isMovingDateProvided,
  isNewNumber,
  userData,
  isMobileNumberProvided,
  newUserSubmit,
  firstStep,
  onCloseAttempt,
  secondStep,
  fourthStep,
  thirdStep,
  sendSimcard,
  sendDataSharingSimcard,
  fifthStep,
  client,
  loggedUserEmail,
  isPartnerOrDstnyAdmin
}) => {
  const onSubmit = useCallback(
    dialogValues => {
      newUserSubmit(
        {
          ...firstStep,
          ...secondStep,
          ...thirdStep,
          ...fourthStep,
          ...dialogValues
        },
        client,
        loggedUserEmail
      );
    },
    // eslint-disable-next-line
    [firstStep, secondStep, thirdStep, fourthStep]
  );

  const onBackClick = useCallback(
    () => {
      setUserData(null, 'fifthStep', true);
      setUserData(
        {
          shipping_address: fifthStep.shipping_address,
          name: fifthStep.name,
          att: fifthStep.att,
          additionalValues: fifthStep.additionalValues
        },
        'fifthStep'
      );
      if (
        isUndefined(secondStep.mobile_number) ||
        isStringEmpty(secondStep.mobile_number)
      ) {
        return handleBack(3);
      }
      return handleBack();
    },
    // eslint-disable-next-line
    [secondStep]
  );
  return (
    <Formik
      initialValues={{
        ...userData.fifthStep,
        isMovingDateProvided,
        isNewNumber,
        isMobileNumberProvided,
        order_confirmation_email:
          loggedUserEmail || userData.fifthStep.order_confirmation_email
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onSubmit}
      validationSchema={validateSchema({ isMobileNumberProvided }).addressStep}
    >
      {({
        handleSubmit,
        errors,
        values,
        handleBlur,
        handleChange,
        setFieldValue
      }) => {
        const fieldProps = { errors, values, handleBlur, handleChange };

        return (
          <Form onSubmit={handleSubmit} className={classes.root}>
            <div className={classes.rowContainer}>
              {(sendSimcard || sendDataSharingSimcard) && (
                <div>
                  <InputRow
                    label="ORDER_SIMCARD.NAME_COMPANY"
                    name="name"
                    {...fieldProps}
                  />
                  <InputRow labelText="Att." name="att" {...fieldProps} />

                  <CustomAddressSelect
                    customLabel="ORDER_SIMCARD.ADDRESS_STEP"
                    selectName="shipping_address"
                    inputName="shipping_address"
                    fieldProps={fieldProps}
                    setFieldValue={setFieldValue}
                    splitLines={true}
                    maxRows={3}
                    menuPlacement="bottom"
                    maxMenuHeight={160}
                    additionalValues={fifthStep.additionalValues}
                  />
                </div>
              )}

              <div>
                {!isMovingDateProvided && isMobileNumberProvided && (
                  <DatepickerRow
                    labelText={`${translate('MOBILE')} ${translate(
                      'ACTIVATION_DATE'
                    ).toLowerCase()}`}
                    name="activation_date"
                    errors={errors}
                    values={values}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isRequired={!values.activationAsap}
                    customStyles={CUSTOM_STYLES.datePicker}
                    shouldDisableDate={false}
                  />
                )}
                <InputRow
                  customStyles={CUSTOM_STYLES.confirm}
                  label="REQUEST_NEW_USER.CONFIRMATION_EMAILS"
                  name="order_confirmation_email"
                  isMultiline={true}
                  maxRows={2}
                  infoIcon={true}
                  infoIconText={translate('TOOLTIP.CONFIRMATION_EMAILS')}
                  {...fieldProps}
                />
                <InputRow
                  customStyles={CUSTOM_STYLES.notes}
                  label="NOTES"
                  name="notes"
                  isMultiline={true}
                  minRows={6}
                  maxRows={4}
                  {...fieldProps}
                />
              </div>
            </div>
            <MandatoryField />
            <div className={classes.autoCreatedInfo}>
              {translate('REQUEST_NEW_USER.AUTO_CREATED_INFO')}
            </div>
            <div className={classes.footer}>
              <PrimaryButton onClick={onBackClick}>
                {translate('BUTTON.BACK')}
              </PrimaryButton>
              <PrimaryButton onClick={handleSubmit}>
                {translate('BUTTON.ORDER_NEW_USER')}
              </PrimaryButton>
              <SecondaryButton onClick={onCloseAttempt || resestUserWizard}>
                {translate('BUTTON.CANCEL')}
              </SecondaryButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStatesToProps = ({
  requestUserWizard: { userData },
  selectClient,
  auth: { user }
}) => {
  const { firstStep, secondStep, thirdStep, fourthStep, fifthStep } = userData;

  const {
    activate_esim,
    data_sharing_card_activate_esim,
    data_sharing_card
  } = thirdStep;
  const isMovingDateProvided =
    isDefined(thirdStep.move_number_date) || thirdStep.is_old_subscripion_date;
  const isNewNumber = secondStep.isNewNumber;
  const isMobileNumberProvided = isStringDefined(secondStep.mobile_number);
  const sendSimcard = fourthStep.send_sim_card;
  const sendDataSharingSimcard = fourthStep.send_sim_card_sharing;

  return {
    firstStep,
    secondStep,
    thirdStep,
    fourthStep,
    fifthStep,
    isMovingDateProvided,
    isNewNumber,
    userData,
    isMobileNumberProvided,
    sendSimcard,
    sendDataSharingSimcard,
    activate_esim,
    data_sharing_card_activate_esim,
    data_sharing_card,
    client: selectClient.selectedClient,
    loggedUserEmail: user.email
  };
};

const mapDispatchToProps = {
  ...reduxActions,
  newUserSubmit
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withUserCheck,
  withStyles(styles)
)(AddressStep);
